<template>
  <div>
    <div class="main-container">
      <div class="editor-container editor-container_classic-editor" ref="editorContainerElement">
        <div class="editor-container__editor">
          <div ref="editorElement">
            <ckeditor @namespaceloaded="onNamespaceLoaded" v-model="editorData" :config="editorConfig" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
  import Vue, { VueConstructor } from 'vue';
  import CKEditor from 'ckeditor4-vue';
  import { addYoutubePlugin } from '../../plugins/youtube/plugin';
  import { setYoutubePluginLang } from '../../plugins/youtube/lang/en';

  interface Injections {
    setHtml: (html: string, contentId: string) => void;
  }

  export default (Vue as VueConstructor<Vue & Injections>).extend({
    name: 'HtmlTextEditor',
    inject: ['setHtml'],
    components: {
      ckeditor: CKEditor.component,
    },
    props: {
      contentId: {
        type: String,
        default: '',
      },
      placeholder: {
        type: String,
        default: '',
      },
      htmlContent: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        editorData: this.htmlContent ?? this.placeholder,
        editorConfig: {
          extraPlugins: 'youtube,colorbutton,colordialog',
          versionCheck: false,
        },
      };
    },
    methods: {
      onNamespaceLoaded(CKEDITOR: any): void {
        addYoutubePlugin(CKEDITOR);
        setYoutubePluginLang(CKEDITOR);
      },
    },
    watch: {
      editorData(html: string) {
        this.setHtml(html, this.contentId);
      },
    },
  });
</script>

<style lang="scss" scoped>
  .custom-editor {
    overflow-y: auto;
    cursor: pointer;

    :deep(.ce-settings) {
      left: -66px;
    }
  }
</style>
